import React, {
  useEffect,
  useState,
} from "react";

import QueryStatusBadge
  from "./QueryStatusBadge";

import {
  QUERY_STATUS_VALUES,
  QUERY_STATUS_LABELS,
} from "../constants/query.constants";

import {
  formatQueryDateTime,
  getQueryAssignedUser,
} from "../utils/query.utils";

import {
  validateQueryUpdate,
} from "../validation/query.validation";


const QueryDetails = ({
  query,
  saving = false,
  deleting = false,
  onUpdate,
  onDelete,
}) => {

  const [form, setForm] =
    useState({
      subject: "",
      message: "",
      status: "",
      offeringId: "",
      pricingPlanId: "",
      assignedTo: "",
    });

  const [errors, setErrors] =
    useState({});


  useEffect(() => {

    if (!query) {
      return;
    }

    setForm({
      subject:
        query.subject || "",

      message:
        query.message || "",

      status:
        query.status || "",

      offeringId:
        query.offering_id || "",

      pricingPlanId:
        query.pricing_plan_id || "",

      assignedTo:
        query.assigned_to || "",
    });

  }, [query]);


  if (!query) {
    return (
      <div className="query-details-empty">
        Query not found.
      </div>
    );
  }


  const handleChange = (
    event
  ) => {

    const {
      name,
      value,
    } = event.target;

    setForm((current) => ({
      ...current,
      [name]: value,
    }));

  };


  const handleSubmit = async (
    event
  ) => {

    event.preventDefault();

    const validationErrors =
      validateQueryUpdate({
        subject: form.subject,
        message: form.message,
      });

    setErrors(validationErrors);

    if (
      Object.keys(validationErrors)
        .length
    ) {
      return;
    }


    const payload = {
      subject:
        form.subject,

      message:
        form.message,

      status:
        form.status || undefined,

      offeringId:
        form.offeringId || undefined,

      pricingPlanId:
        form.pricingPlanId || undefined,

      assignedTo:
        form.assignedTo || null,
    };


    await onUpdate?.(
      query.id,
      payload
    );
  };


  return (
    <div className="query-details">

      <div className="query-details-header">

        <div>

          <h2>
            {query.subject ||
              "Query Details"}
          </h2>

          <span>
            Created{" "}
            {formatQueryDateTime(
              query.created_at
            )}
          </span>

        </div>

        <QueryStatusBadge
          status={query.status}
        />

      </div>


      {/* CLIENT */}

      <section className="query-details-section">

        <h3>
          Client Information
        </h3>

        <div className="query-info-grid">

          <div>
            <label>Name</label>
            <p>
              {query.client_name ||
                "-"}
            </p>
          </div>


          <div>
            <label>Company</label>
            <p>
              {query.client_company_name ||
                "-"}
            </p>
          </div>


          <div>
            <label>Email</label>
            <p>
              {query.client_email ||
                "-"}
            </p>
          </div>


          <div>
            <label>Phone</label>
            <p>
              {query.client_phone ||
                "-"}
            </p>
          </div>

        </div>

      </section>


      {/* QUERY */}

      <section className="query-details-section">

        <h3>
          Query Information
        </h3>


        <form
          onSubmit={handleSubmit}
          className="query-edit-form"
        >

          <div className="query-form-field">

            <label>
              Subject
            </label>

            <input
              type="text"
              name="subject"
              value={form.subject}
              onChange={handleChange}
              maxLength={250}
            />

            {errors.subject && (
              <span className="query-field-error">
                {errors.subject}
              </span>
            )}

          </div>


          <div className="query-form-field">

            <label>
              Message
            </label>

            <textarea
              name="message"
              value={form.message}
              onChange={handleChange}
              rows={8}
            />

            {errors.message && (
              <span className="query-field-error">
                {errors.message}
              </span>
            )}

          </div>


          {/* STATUS */}

          <div className="query-form-field">

            <label>
              Status
            </label>

            <select
              name="status"
              value={form.status}
              onChange={handleChange}
            >

              {QUERY_STATUS_VALUES.map(
                (status) => (
                  <option
                    key={status}
                    value={status}
                  >
                    {
                      QUERY_STATUS_LABELS[
                        status
                      ]
                    }
                  </option>
                )
              )}

            </select>

          </div>


          {/* RELATED DATA */}

          <div className="query-related-grid">

            <div>

              <label>
                Offering
              </label>

              <div className="query-related-value">
                {query.offering_name ||
                  "Not assigned"}
              </div>

            </div>


            <div>

              <label>
                Pricing Plan
              </label>

              <div className="query-related-value">
                {query.pricing_plan_name ||
                  "Not assigned"}
              </div>

            </div>


            <div>

              <label>
                Assigned To
              </label>

              <div className="query-related-value">
                {getQueryAssignedUser(
                  query
                )}
              </div>

            </div>

          </div>


          <div className="query-details-actions">

            <button
              type="submit"
              disabled={saving}
              className="query-save-button"
            >
              {saving
                ? "Saving..."
                : "Save Changes"}
            </button>


            {onDelete && (
              <button
                type="button"
                disabled={deleting}
                className="query-delete-button"
                onClick={() =>
                  onDelete(query.id)
                }
              >
                {deleting
                  ? "Deleting..."
                  : "Delete Query"}
              </button>
            )}

          </div>

        </form>

      </section>

    </div>
  );
};


export default QueryDetails;